import { Components, Theme } from "@mui/material";

export const muiCard: Components<Omit<Theme, "components">> = {
  MuiCard: {
    defaultProps: {
      variant: "outlined"
    }
  }
};
